import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImageSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImageSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM4.5 4.5V14.4393L8 10.9393L16.5607 19.5H19.5V4.5H4.5Z" fill="currentColor"/><Path d="M13.5 8.5L14.5 6.5L15.5 8.5L17.5 9.5L15.5 10.5L14.5 12.5L13.5 10.5L11.5 9.5L13.5 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImageSparkle;
